module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/status-report-one-month-before/status-report-one-month-before.component.scss
// module id = ./client/app/status-report-one-month-before/status-report-one-month-before.component.scss
// module chunks = main